/**
 * Shape of template parameters accepted by the console i18n runtimes.
 * Templates reference params via `{name}`.
 */
export type TParams = Readonly<Record<string, string | number>>;

/**
 * Render a template with `{name}` placeholders against a params object.
 *
 * Rules:
 * - Unknown placeholders stay literal (`{foo}`) so missing data is visible.
 * - Unused params are ignored.
 * - No escape sequences; dictionary authors should avoid literal braces.
 */
const PLACEHOLDER_PATTERN = /\{(\w+)\}/g;

export function substitute(template: string, params: TParams | undefined): string {
  if (params === undefined) {
    return template;
  }
  return template.replace(PLACEHOLDER_PATTERN, (match, rawKey: string) => {
    const value = params[rawKey];
    if (value === undefined) {
      return match;
    }
    return String(value);
  });
}
